import { render } from "./manage_risks.html?vue&type=template&id=2844a812&external"
import script from "./manage_risks.js?vue&type=script&lang=js&external"
export * from "./manage_risks.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__